export default class CardRow extends React.Component {
  render() {
    const {className, ...restProps} = this.props

    return (
      <div className={classNames("components-card-row", className)} {...restProps} />
    )
  }
}
